// TODO: check + ensure all locales are not being included/bundled into output
import { parseISO } from "date-fns";

export default function getTimezoneOffsetDate(utcDateString) {
  const date = parseISO(utcDateString);
  const timezoneOffset = date.getTimezoneOffset() * -60000;
  return new Date(date.getTime() + timezoneOffset);
}
